export enum USER_DETAIL_POPUP_TYPE {
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  CHANGE_EMAIL = 'CHANGE_EMAIL',
  VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST',
  DELETE_USER_DATA = 'DELETE_USER_DATA',
}
